
ProductCheckoutLinkCtrl.$inject = ["$uibModalInstance", "product", "notifications", "$http", "store"];angular.module('dnecom').controller('ProductCheckoutLinkCtrl', ProductCheckoutLinkCtrl);

function ProductCheckoutLinkCtrl($uibModalInstance, product, notifications, $http, store) {
    const vm = this;

    /** {attributeId: chosenAttributeValueId} */
    vm.inputModel = {};
    vm.attributes = [];
    vm.variants = [];
    vm.currentPrice = product.currentPrice;
    vm.product = product;
    vm.buttonTitle = 'Buy Now';
    vm.variant = null;
    vm.checkoutLink = null;
    vm.checkoutButton = null;

    vm.close = close;
    vm.getColorByValueId = getColorByValueId;
    vm.copyToClipboard = copyToClipboard;
    vm.updateCheckoutLink = updateCheckoutLink;
    vm.previewCheckoutButton = previewCheckoutButton;
    vm.isPresentInVariant = isPresentInVariant;

    if (!vm.product.hasAttributes && vm.product.defaultVariant) {
        setCheckoutLink(vm.product.defaultVariant)
    } else {
        $http
            .get(
                Routing.generate('products_attributes_get', {
                    id: store.id,
                    productId: product.id
                })
            )
            .then(function (response) {
                if (response.data.success) {
                    vm.attributes = response.data.attributes;
                    vm.variants = response.data.variants;
                } else {
                    notifications.danger(response.data.message);
                }
            }, function () {
                notifications.danger('Request error');
            });
    }

    function getColorByValueId(attributeId, attributeValueId) {
        attributeId = parseInt(attributeId);
        attributeValueId = parseInt(attributeValueId);
        const attribute = _.find(vm.attributes, o => o.id === attributeId);
        const attrValue = _.find(attribute.values, o => o.id === attributeValueId);
        const color = _.get(attrValue, 'color');
        return `#${color}`;
    }

    function copyToClipboard(id) {
        const element = document.getElementById(id);
        element.select();
        element.setSelectionRange(0, 99999);
        document.execCommand('copy');
        if (id === 'checkoutLink') {
            notifications.success('Checkout link copied.');
        }
        if (id === 'checkoutButton') {
            notifications.success('Button HTML code copied.');
        }
    }

    function updateCheckoutLink() {
        vm.checkoutLink = null;
        vm.checkoutButton = null;
        let variant = null;
        if (_.values(vm.inputModel).length === vm.attributes.length) {
            const chosenAttrValueIds = _.map(vm.inputModel, o => parseInt(o));
            variant = findVariantByValues(chosenAttrValueIds);
        }
        if (!vm.product.hasAttributes && vm.product.defaultVariant) {
            variant = vm.product.defaultVariant;
        }

        if (variant) {
            setCheckoutLink(variant)
        }
    }

    function setCheckoutLink(variant) {
        vm.checkoutLink = generateCheckoutLink(variant.sku);
        vm.currentPrice = variant.currentPrice;
        vm.checkoutButton =
`<style>
    .ies-buy-now {
        display:inline-block;
        background:#45bf22;
        padding:12px 18px !important;
        font-size:18px;color:white !important; 
        box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.35);
        text-decoration:none !important;
        font-family:sans-serif;
        font-weight:500;
        text-align:center;
    }
    .ies-buy-now:hover {
        background:#4dd526;
    }
</style>
<a href="${vm.checkoutLink}" class="ies-buy-now">${vm.buttonTitle}</a>`;
        previewCheckoutButton();
    }

    function previewCheckoutButton() {
        const button = document.getElementById('buttonPreview');
        if (button) {
            button.innerHTML = vm.checkoutButton;
        }
    }

    function isPresentInVariant(attributeId, valueId) {
        /**
         * Get selected value ids by only other <select>'s
         */
        let chosenAttrValueIds = _.filter(
            vm.inputModel,
            (chosenAttributeValueId, chosenAttributeId) => parseInt(chosenAttributeId) !== attributeId && !_.isUndefined(chosenAttributeValueId)
        );
        chosenAttrValueIds = _.map(chosenAttrValueIds, o => parseInt(o));
        chosenAttrValueIds.push(valueId);
        const variant = findVariantByValues(chosenAttrValueIds);

        return !!variant;
    }

    function findVariantByValues(chosenAttrValueIds) {
        return _.find(vm.variants, variant => {
            if (variant.quantity === 0 || !variant.isEnabled) {
                return false;
            }

            let combValueIds = [];
            _.forEach(variant.combination, o => {
                if (_.includes(chosenAttrValueIds, o.id)) {
                    combValueIds.push(o.id);
                }
            });
            return combValueIds.length === chosenAttrValueIds.length ? variant : null;
        });
    }

    function generateCheckoutLink(sku) {
        const store = TemplateData.value('store');
        const protocol = window.location.protocol;
        let path = Routing.generate('stores_fe_product_checkout_link', {
            sku: sku
        });

        if (store.domain) {
            return `${protocol}//${store.domain}${path}`;
        }

        if (store.subdomain) {
            return `${protocol}//${store.subdomain}.${window.ies.domain}${path}`;
        }
    }

    function close() {
        $uibModalInstance.close();
    }
}
